<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span><i>Also by Evelyn Anthony</i></span></p>
<p class="fm1"><span>Anne Boleyn</span></p>
<p class="fm1"><span>Charles the King</span></p>
<p class="fm1"><span>Clandara</span></p>
<p class="fm1"><span>Curse Not the King</span></p>
<p class="fm1"><span>Elizabeth</span></p>
<p class="fm1"><span>Imperial Highness</span></p>
<p class="fm1"><span>Victoria</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?4dffdb1d